let tTimeoutId: any = null

let pendingLabels: [string, string, (value: unknown) => void, (reason?: any) => void][] = []

async function computeLabel(schemaName: string, modelId: string) {
  const label = new Promise((resolve, reject) => {
    pendingLabels.push([schemaName, modelId, resolve, reject])
  })
  // wait 1 tick to collect labels
  tTimeoutId =
    tTimeoutId ||
    setTimeout(async () => {
      tTimeoutId = null
      const beingComputed = pendingLabels
      pendingLabels = []
      const labels = await fetch('/_cnc/labels', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          labels: beingComputed.map(([schemaName, modelId]) => [schemaName, modelId])
        })
      }).then((res) => res.json())
      beingComputed.forEach(([, , resolve], i) => resolve(labels[i]))
    }, 0)

  return label
}

export function labelMagic() {
  return computeLabel
}
